/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumModelSchema } from "../albumModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAlbumsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома.")
    })

/**
 * @description Альбом
 */
export const getApiAlbumsId200Schema = z.lazy(() => albumModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAlbumsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAlbumsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAlbumsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден
 */
export const getApiAlbumsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAlbumsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAlbumsIdQueryResponseSchema = z.lazy(() => getApiAlbumsId200Schema)